<div class="container__confirmation-dialog-header">
  <button mat-icon-button mat-dialog-close aria-label="Close">
    <mat-icon fontSet="material-icons-outlined">close</mat-icon>
  </button>
</div>
<mat-dialog-content [class]="modalPanelClass">
  <div class="container__confirmation-dialog-content-img">
    <img width="48px" height="48px" src="assets/images/icons/warning-modal.png" alt="icon confirmation modal">
  </div>
  <div class="container__confirmation-dialog-content-text">
    <h1 class="h6_500">{{ title | translate}}</h1>
    <p *ngIf="subtitle" class="s1_500">{{ subtitle | translate}}</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="container__confirmation-dialog-actions">
  <common-buttons-filled *ngIf="labelButtonSave" class="filters-rigth-create-server" [label]="labelButtonSave | translate"
    [disabled]="false" (output)="onEventSave(true)"></common-buttons-filled>

  <common-buttons-outlined *ngIf="labelButtonCancel" class="filters-left-create-server" [label]="labelButtonCancel | translate"
    [iconPosition]="false" (output)="onEventCancel(false)"></common-buttons-outlined>
</mat-dialog-actions>